import { useEffect } from 'react';

const PaymentMasterCardSuccess = (props: { onBack: () => void }) => {
  document.addEventListener('sonicCompletion', () => {
    setTimeout(() => {
      props.onBack();
    }, 1000);
  });

  useEffect(() => {
    const el = document.getElementById('mc-sonic');
    // @ts-ignore
    el.play();
  }, []);

  return (
    <div id="animationStep" className="size-full">
      {/* @ts-ignore */}
      <mc-sonic
        id="mc-sonic"
        sonicBackground="white"
        type="default"
        sonicCue="securedby"
      />
    </div>
  );
};

export default PaymentMasterCardSuccess;
